import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoService extends BaseService {
  private baseUrl = '/profile';

  uploadPic(formData: any): Observable<any> {
    return this.basePostMultiPart(`${this.baseUrl}/upload`, formData);
  }

  findUser(email: string): Observable<any> {
    return this.baseGet(`${this.baseUrl}/findUser/${email}`);
  }
}
